<template>
    <div id="app-layout-right-column">
        <div id="app-layout-right-column__navigation" class="d-flex flex-column px-2 py-3">
            <ShowProjectsButton />
            <ShowProjectTreeButton :class="{'v-btn--active': isRightColumn('project')}" />
            <ShowCandidatesButton :class="{'v-btn--active': isRightColumn('candidates')}" />
            <ShowMatchesButton :class="{'v-btn--active': isRightColumn('matches')}" />
            <ShowCommentsButton :class="{'v-btn--active': isRightColumn('comments')}" />
            <ShowPresetsButton :class="{'v-btn--active': isRightColumn('presets')}" />
            <div class="group-separator"></div>
            <DownloadLUTButton :class="{'v-btn--active': isRightColumn('download-lut')}" />
            <DownloadXMPButton :class="{'v-btn--active': isRightColumn('download-xmp')}" />
            <DownloadCOButton :class="{'v-btn--active': isRightColumn('download-co')}" />
            <DownloadImageButton :class="{'v-btn--active': isRightColumn('download-image')}" />
            <div class="group-separator"></div>
            <DownloadPremiereExtensionButton :class="{'v-btn--active': isRightColumn('download-premiere-extension')}" />
        </div>

        <div id="app-layout-right-column__content">
            <ProjectTree v-show="isRightColumn('project')" />
            <Candidates v-show="isRightColumn('candidates')" />
            <Matches v-show="isRightColumn('matches')" />
            <Presets v-show="isRightColumn('presets')" />
            <Comments v-show="isRightColumn('comments')" />
            <DownloadLUT v-show="isRightColumn('download-lut')" />
            <DownloadXMP v-show="isRightColumn('download-xmp')" />
            <DownloadCO v-show="isRightColumn('download-co')" />
            <DownloadImage v-show="isRightColumn('download-image')" />
            <DownloadPremiereExtension v-show="isRightColumn('download-premiere-extension')" />
        </div>
    </div>
</template>

<script>
import Comments from '@/components/app/comments/Index';
import ShowProjectsButton from "@/components/app/buttons/ShowProjectsButton.vue";
import ShowProjectTreeButton from "@/components/app/buttons/ShowProjectTreeButton.vue";
import ShowCandidatesButton from "@/components/app/buttons/ShowCandidatesButton.vue";
import ShowMatchesButton from "@/components/app/buttons/ShowMatchesButton.vue";
import ShowCommentsButton from "@/components/app/buttons/ShowCommentsButton.vue";

import { mapGetters } from "vuex";
import DownloadImageButton from "@/components/app/buttons/DownloadImageButton.vue";
import ProjectTree from "@/components/app/project-tree/ProjectTree.vue";
import DownloadLUT from "@/components/app/export/DownloadLUT.vue";
import DownloadXMP from "@/components/app/export/DownloadXMP.vue";
import DownloadCO from "@/components/app/export/DownloadCO.vue";
import DownloadImage from "@/components/app/export/DownloadImage.vue";
import DownloadPremiereExtension from "@/components/app/extensions/DownloadPremiereExtension.vue";
import Matches from "@/components/app/matches/Matches.vue";
import Candidates from "@/components/app/candidates/Candidates.vue";
import DownloadLUTButton from "@/components/app/buttons/DownloadLUTButton.vue";
import DownloadXMPButton from "@/components/app/buttons/DownloadXMPButton.vue";
import ShowPresetsButton from "@/components/app/buttons/ShowPresetsButton.vue";
import Presets from "@/components/app/presets/Presets.vue";
import DownloadCOButton from "@/components/app/buttons/DownloadCOButton.vue";
import DownloadPremiereExtensionButton from "@/components/app/buttons/DownloadPremiereExtensionButton.vue";

export default {
    name: "AppLayoutRightColumn",
    components: {
        DownloadCOButton,
        Presets,
        ShowPresetsButton,
        Candidates,
        Matches,
        ProjectTree,
        DownloadLUT,
        DownloadXMP,
        DownloadCO,
        DownloadPremiereExtension,
        DownloadImageButton,
        Comments,
        ShowProjectsButton,
        ShowProjectTreeButton,
        ShowCandidatesButton,
        ShowMatchesButton,
        ShowCommentsButton,
        DownloadLUTButton,
        DownloadXMPButton,
        DownloadImage,
        DownloadPremiereExtensionButton
    },
    computed: {
        ...mapGetters('UI', ['isRightColumn']),
        ...mapGetters("User", ["isCurrentPlanFree"]),
    }
}
</script>

<style lang="scss" scoped>
#app-layout-right-column {
    border-radius: var(--box-rounding) 0 0 var(--box-rounding);
    height: 100%;
    display: grid;
    grid-template-columns: auto minmax(0, 100%);
    grid-template-rows: minmax(0, 100%);

    &__navigation {
        gap: 8px;
        border-right: 1px solid var(--color-group-separator);

        ::v-deep .v-btn {
            min-width: auto;
            height: auto;
            box-shadow: none;
            background-color: transparent;
            color: var(--font-default-color);
            padding: 3px;

            &--active {
                &::before {
                    background-color: var(--color-accent);
                    opacity: 0.4;
                }
            }

            &--disabled,
            &--disabled .v-icon {
                background-color: transparent !important;
                color: var(--font-default-color) !important;
                opacity: 0.4;
            }

            i {
                font-size: 1.7rem;
            }
        }

        .group-separator {
            width: 100%;
            border-bottom: 1px solid var(--color-group-separator);
            margin: 10px 0;
        }
    }

    &__content {
        display: grid;
        grid-template-rows: minmax(0, 100%);
        padding: 4px 8px;

        ::v-deep &__title {
            font-size: 1.2rem;
            font-weight: bold;
            line-height: 1.4;
            text-align: left;
            padding: 10px 0;
            color: var(--color-title-light);
            position: relative;
        }

        ::v-deep &__message {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            //transform: translateY(-50%);

            > span {
                line-height: 1.5;
                text-align: center;
                text-transform: uppercase;
            }
        }
    }
}
</style>